import { Box } from '@chakra-ui/react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts'
import { useChartTheme } from '../../../hooks/useChartTheme'
import CustomTooltip from './CustomTooltip'
import { brand } from '../../../theme'
import type { RouteAnalytics } from '../../../data/mockEstadisticas'

interface RoutePerformanceChartProps {
  data: RouteAnalytics[]
}

export default function RoutePerformanceChart({ data }: RoutePerformanceChartProps) {
  const { axis, grid } = useChartTheme()

  const chartData = data.map((r) => ({
    ruta: `${r.origen.split(' ')[0]} → ${r.destino.split(' ')[0]}`,
    traslados: r.trasladosCompletados,
    tonelaje: r.tonelajeTransportado,
  }))

  return (
    <Box h="320px">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData}>
          <CartesianGrid stroke={grid.stroke} strokeDasharray={grid.strokeDasharray} />
          <XAxis dataKey="ruta" stroke={axis.stroke} tick={{ ...axis.tick, fontSize: 10 }} />
          <YAxis yAxisId="left" stroke={axis.stroke} tick={axis.tick} />
          <YAxis yAxisId="right" orientation="right" stroke={axis.stroke} tick={axis.tick} tickFormatter={(v: number) => `${(v / 1000).toFixed(0)}k`} />
          <Tooltip content={<CustomTooltip formatter={(v, name) => name === 'Tonelaje' ? `${v.toLocaleString()} TM` : v.toLocaleString()} />} />
          <Legend wrapperStyle={{ fontSize: 11, fontFamily: "'Instrument Sans', sans-serif" }} />
          <Bar yAxisId="left" dataKey="traslados" name="Traslados" fill={brand.green} radius={[4, 4, 0, 0]} barSize={24} />
          <Bar yAxisId="right" dataKey="tonelaje" name="Tonelaje" fill="#3d6fa8" radius={[4, 4, 0, 0]} barSize={24} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  )
}
